import { Box, styled, Switch, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const NotificationVisibilityGap = styled(Box)<{ separator: string }>(({ separator }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    borderBottom: separator === 'true' ? `1px solid ${palette.border.default}` : 'none',
    paddingBottom: separator === 'true' ? '24px' : 0,
    marginBottom: separator === 'true' ? '24px' : 0,
  };
});

export const Header = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}) as typeof Box;

export const HeaderTitle = styled(Typography)({
  color: palette.text.header,
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20.48px',
  letterSpacing: '0',
}) as typeof Typography;

export const HeaderSubTitle = styled(Typography)({
  color: palette.unknown.sub_title_grey,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '19.04px',
  letterSpacing: '0',
}) as typeof Typography;

export const MainItem = styled(Box)({
  minHeight: '40px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '> p': {
    color: palette.text.header,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21.76px',
    letterSpacing: '0',
  },
}) as typeof Box;

export const CustomSwitch = styled(Switch)({
  width: 24,
  height: 14,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 1,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(10px)',
      color: palette.white,
      '& + .MuiSwitch-track': {
        backgroundColor: palette.accent.green500,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: palette.accent.green500,
      border: '3px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: palette.white,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 12,
    height: 12,
  },
  '& .MuiSwitch-track': {
    borderRadius: '100px',
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: 'background-color 500ms',
  },
});
